module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon",
    class: _vm.iconClass
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62dbcdc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FavoriteButton.vue
// module id = 137
// module chunks = 0